const testimonials = [
  {
    name: 'Sophie M.',
    role: 'Infirmière, 34 ans',
    rating: 5,
    text: 'Grâce à LS INVEST, j\'ai enfin compris comment investir intelligemment. En 8 mois, mon portefeuille a progressé de +18%. Je recommande à 100% !',
  },
  {
    name: 'Thomas R.',
    role: 'Ingénieur, 28 ans',
    rating: 5,
    text: 'J\'avais déjà essayé d\'autres formations, mais LS INVEST est la seule qui donne des outils concrets. Les modules sur la gestion du risque sont gold.',
  },
  {
    name: 'Marie-Claire L.',
    role: 'Comptable, 41 ans',
    rating: 5,
    text: 'Je partais de zéro, je ne connaissais rien à la Bourse. Aujourd\'hui j\'ai un portefeuille de 15 000€ et je suis sereine. Merci LS INVEST !',
  },
  {
    name: 'Kevin D.',
    role: 'Entrepreneur, 31 ans',
    rating: 5,
    text: 'La communauté Discord est incroyable, les échanges sont de qualité. Et avoir accès au portefeuille en temps réel... c\'est une valeur énorme.',
  },
];

const TestimonialsSection = () => (
  <section className="bg-[#F5F0FF] py-16 px-8 lg:px-16">
    <div className="max-w-[1272px] mx-auto">
      <div className="text-center mb-10">
        <h2 className="text-[#1E0750] font-black text-3xl lg:text-4xl">
          Et ce n&apos;est pas moi qui le dit !
        </h2>
        <p className="text-[#1E0750]/60 text-sm mt-3">Ce que disent les membres de la communauté LS INVEST</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {testimonials.map((t, i) => (
          <div key={i} className="bg-white border border-[#E2D9F3] rounded-2xl p-6 flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#1E0750] flex items-center justify-center flex-shrink-0">
                <span className="text-[#A3E635] font-bold text-sm">{t.name[0]}</span>
              </div>
              <div>
                <div className="text-[#1E0750] font-bold text-sm">{t.name}</div>
                <div className="text-[#1E0750]/50 text-xs">{t.role}</div>
              </div>
              <div className="ml-auto text-[#F0C932] text-sm tracking-tight">
                {'★'.repeat(t.rating)}
              </div>
            </div>
            <p className="text-[#1E0750]/70 text-sm leading-relaxed">&ldquo;{t.text}&rdquo;</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TestimonialsSection;
